




























































































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import MyApp from "./components/myApp.vue";
import Zhfw from "./components/zhfw.vue";
import MyWork from "./components/myWork.vue";
import CService from "./components/cService/index.vue";
import MyService from "./components/cService/myindex.vue";
import cToolsDoc from "./components/cToolsDoc/index.vue";
import RightNav from "./components/rightNav/index.vue";
import solarLunar from "solarlunar";

@Component({
  name: "Home",
  components: {
    MyApp,
    MyWork,
    CService,
    MyService,
    cToolsDoc,
    RightNav,
    Zhfw
  }
})
export default class Home extends Base {
  private noticeSource: any[] = [];
  private releaseSource: any[] = [];
  private systemTime: any = {};
  private dataSource: any[] = [];

  private created() {
    // console.log(solarLunar.solar2lunar(2021, 1, 28));
    this.getSystemTime();
    this.getNoticeList();
    this.getRelaseList();
  }
  private get list() {
    const step = 6;
    const _return: any[] = Array.from({ length: Math.ceil(this.dataSource.length / step) }, () => []);
    for (let i = 0; i < _return.length; i++) {
      for (let j = i * step; j < i * step + step; j++) {
        if (this.dataSource[j]) {
          _return[i].push(this.dataSource[j]);
        } else {
          break;
        }
      }
    }
    return _return;
  }

  private async getNoticeList() {
    const res = await this.$api.NoticeList({
      pageNum: 1,
      pageSize: 3
    });
    if (res && res.code === 200) {
      this.noticeSource = res.rows;
    }
  }
  private async getRelaseList() {
    const res = await this.$api.ReleaseList({
      pageNum: 1,
      pageSize: 5
    });
    if (res && res.code === 200) {
      this.releaseSource = res.rows;
      console.log('releaseSource=========', this.releaseSource);
    }
  }

  private async getSystemTime() {
    const res = await this.$api.SystemTime();
    if (res && res.code === 200) {
      const date = new Date(res.data);
      this.systemTime = solarLunar.solar2lunar(date.getFullYear(), date.getMonth() + 1, date.getDate());
    }
  }
}
